export const CATEGORIES = [
    { id: 1, name: 'Уход за телом', slug: 'body-care' },
    { id: 2, name: 'Уход за руками', slug: 'hand-care' },
    { id: 3, name: 'Уход за ногами', slug: 'foot-care' },
    { id: 4, name: 'Уход за лицом', slug: 'face-care' },
    { id: 5, name: 'Уход за волосами', slug: 'hair-care' },
    { id: 6, name: 'Средства для загара', slug: 'tanning' },
    { id: 7, name: 'Средства для бритья', slug: 'shaving' },
    { id: 8, name: 'Подарочные наборы', slug: 'gifts' },
    { id: 9, name: 'Гигиеническая продукция', slug: 'hygiene' },
    { id: 10, name: 'Гигиена полости рта', slug: 'oral-hygiene' },
    { id: 11, name: 'Бумажная продукция', slug: 'paper' },
];
